export default "__VITE_ASSET__DZHgMcfu__"